module.exports = __webpack_public_path__ + "img/code.f08b006a.svg";